// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/CampTicket.css */

.camp-ticket {
    padding: 15px;
    width: 300px;
    text-align: center;
    margin: 10px;
    background: #f3af4a;
    position: relative;
  }
  .camp-ticket-container{
    border: 2px solid #000;
    background: #f8ece4;
  }
  
.circle-container:nth-child(1)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 20px;
}
.circle-container:nth-child(2)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 60px;
}
.circle-container:nth-child(3)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 100px;
}
      
.circle-container:nth-child(4)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 140px;
}
      
.circle-container:nth-child(5)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 180px;
}
      
.circle-container:nth-child(6)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 220px;
}
.circle-container:nth-child(7)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: -4%;
    transform: translateY(0);
    left: 260px;
}
 /* Right side   */
.circle-container:nth-child(8)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 20px;
    transform: translateY(-50%);
    right: -10px;
} 
.circle-container:nth-child(9)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 60px;
    transform: translateY(-50%);
    right: -10px;
}    
.circle-container:nth-child(10)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 100px;
    transform: translateY(-50%);
    right: -10px;
}    
.circle-container:nth-child(11)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 140px;
    transform: translateY(-50%);
    right: -10px;
}   
.circle-container:nth-child(13)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 180px;
    transform: translateY(-50%);
    right: -10px;
} 
.circle-container:nth-child(14)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 220px;
    transform: translateY(-50%);
    right: -10px;
} 
.circle-container:nth-child(15)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 260px;
    transform: translateY(-50%);
    right: -10px;
} 
/* Left Circles */
.circle-container:nth-child(16)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 20px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(17)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 60px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(18)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 100px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(19)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 140px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(20)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 180px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(21)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 220px;
    transform: translateY(-50%);
    left: -11px;
} 
.circle-container:nth-child(22)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    top: 260px;
    transform: translateY(-50%);
    left: -11px;
} 
/* Bottom circles */
.circle-container:nth-child(23)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 30px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(24)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 70px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(25)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 110px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(26)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 150px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(27)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 190px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(29)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 230px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}
.circle-container:nth-child(30)::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
   background: #f8ece4;
    border-radius: 50%;
    bottom: -10px; /* Position circle at the bottom */
    left: 270px; /* Center circle horizontally */
    transform: translateX(-50%); /* Adjust centering */
}


.camp-ticket__header {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 2px solid #000;
  }
  
  .camp-ticket__date {
    font-size: 16px;
    margin: 10px 0;
    padding-bottom: 4%;
    font-weight: bold;
    border-bottom:2px solid #000;
  }
  
  .camp-ticket__details {
    display: flex;
    justify-content: space-around;
    margin: 10px 0;
    border-bottom:2px solid #000;
    padding-bottom: 3%;
  }
  
  .camp-ticket__detail-item {
    font-size: 14px;
    font-weight: 700;
  }
  
  .camp-ticket__price {
    font-size: 18px;
    margin: 10px 0;
    font-weight: bold;
    border-bottom:2px solid #000;
  }
  
  .camp-ticket__seats {
    font-size: 12px;
    margin: 10px 0;
    font-weight: 700;
  }
  
  .camp-ticket__button {
    background: #292e46;
    border: none;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    color: #fff;
    width: 100%;
    color:#F8ECE4;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Parents/components/CampTicket.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,WAAW;AACf;CACC,iBAAiB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,YAAY;AAChB;AACA,iBAAiB;AACjB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA,mBAAmB;AACnB;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,UAAU,EAAE,+BAA+B;IAC3C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,UAAU,EAAE,+BAA+B;IAC3C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,WAAW,EAAE,+BAA+B;IAC5C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,WAAW,EAAE,+BAA+B;IAC5C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,WAAW,EAAE,+BAA+B;IAC5C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,WAAW,EAAE,+BAA+B;IAC5C,2BAA2B,EAAE,qBAAqB;AACtD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;GACb,mBAAmB;IAClB,kBAAkB;IAClB,aAAa,EAAE,kCAAkC;IACjD,WAAW,EAAE,+BAA+B;IAC5C,2BAA2B,EAAE,qBAAqB;AACtD;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,WAAW;IACX,aAAa;EACf","sourcesContent":["/* src/components/CampTicket.css */\n\n.camp-ticket {\n    padding: 15px;\n    width: 300px;\n    text-align: center;\n    margin: 10px;\n    background: #f3af4a;\n    position: relative;\n  }\n  .camp-ticket-container{\n    border: 2px solid #000;\n    background: #f8ece4;\n  }\n  \n.circle-container:nth-child(1)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 20px;\n}\n.circle-container:nth-child(2)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 60px;\n}\n.circle-container:nth-child(3)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 100px;\n}\n      \n.circle-container:nth-child(4)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 140px;\n}\n      \n.circle-container:nth-child(5)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 180px;\n}\n      \n.circle-container:nth-child(6)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 220px;\n}\n.circle-container:nth-child(7)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: -4%;\n    transform: translateY(0);\n    left: 260px;\n}\n /* Right side   */\n.circle-container:nth-child(8)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 20px;\n    transform: translateY(-50%);\n    right: -10px;\n} \n.circle-container:nth-child(9)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 60px;\n    transform: translateY(-50%);\n    right: -10px;\n}    \n.circle-container:nth-child(10)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 100px;\n    transform: translateY(-50%);\n    right: -10px;\n}    \n.circle-container:nth-child(11)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 140px;\n    transform: translateY(-50%);\n    right: -10px;\n}   \n.circle-container:nth-child(13)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 180px;\n    transform: translateY(-50%);\n    right: -10px;\n} \n.circle-container:nth-child(14)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 220px;\n    transform: translateY(-50%);\n    right: -10px;\n} \n.circle-container:nth-child(15)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 260px;\n    transform: translateY(-50%);\n    right: -10px;\n} \n/* Left Circles */\n.circle-container:nth-child(16)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 20px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(17)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 60px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(18)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 100px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(19)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 140px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(20)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 180px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(21)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 220px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n.circle-container:nth-child(22)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    top: 260px;\n    transform: translateY(-50%);\n    left: -11px;\n} \n/* Bottom circles */\n.circle-container:nth-child(23)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 30px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(24)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 70px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(25)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 110px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(26)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 150px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(27)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 190px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(29)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 230px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n.circle-container:nth-child(30)::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n   background: #f8ece4;\n    border-radius: 50%;\n    bottom: -10px; /* Position circle at the bottom */\n    left: 270px; /* Center circle horizontally */\n    transform: translateX(-50%); /* Adjust centering */\n}\n\n\n.camp-ticket__header {\n    padding: 10px;\n    font-size: 18px;\n    font-weight: bold;\n    border-bottom: 2px solid #000;\n  }\n  \n  .camp-ticket__date {\n    font-size: 16px;\n    margin: 10px 0;\n    padding-bottom: 4%;\n    font-weight: bold;\n    border-bottom:2px solid #000;\n  }\n  \n  .camp-ticket__details {\n    display: flex;\n    justify-content: space-around;\n    margin: 10px 0;\n    border-bottom:2px solid #000;\n    padding-bottom: 3%;\n  }\n  \n  .camp-ticket__detail-item {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  \n  .camp-ticket__price {\n    font-size: 18px;\n    margin: 10px 0;\n    font-weight: bold;\n    border-bottom:2px solid #000;\n  }\n  \n  .camp-ticket__seats {\n    font-size: 12px;\n    margin: 10px 0;\n    font-weight: 700;\n  }\n  \n  .camp-ticket__button {\n    background: #292e46;\n    border: none;\n    padding: 10px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    color: #fff;\n    width: 100%;\n    color:#F8ECE4;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
